import { createSlice } from "@reduxjs/toolkit";

export const eddSlice = createSlice({
  name: "edd",
  initialState: {
    edd_setting: {
      enabled: "0",
      cutoff_time: "16",
      processing_time: "1",
      business_days: "[2,3,4,5,6]",
      timezone: "+0",
    },
    transit_time: [
      {
        shipping_destination_country: "[]",
        shipping_method:
          '[{"courier":["any shipping method"],"first":"3","second":"5"}]',
      },
    ],
  },
  reducers: {
    setEdd: (state, action) => {
      const edd = action.payload;
      return edd;
    },
  },
});

export const { setEdd } = eddSlice.actions;

export default eddSlice.reducer;
